/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ReturnPage = lazyLoad(
  () => import('./index'),
  module => module.ReturnPage
);
